(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fa-fishing-report"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STATIONS = {
      '8726520': { name: 'St. Petersburg, Tampa Bay', lat: 27.7606, lon: -82.6269 },
      '8726347': { name: 'Egmont Key, Tampa Bay', lat: 27.6017, lon: -82.76 },
      '8726607': { name: 'Old Port Tampa', lat: 27.8578, lon: -82.5528 },
      '8726724': { name: 'Clearwater Beach', lat: 27.9783, lon: -82.8317 }
    };
    const CACHE_TTL = 10 * 60 * 1000;

    const roots = document.querySelectorAll('[data-fa-report]');
    if (!roots.length) return;

    const track = (event, data = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...data });
      if (typeof window.fbq === 'function') window.fbq('trackCustom', event, data);
    };

    const formatStationNow = () => {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date()).reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {});
      return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
    };

    const apiDate = () => formatStationNow().slice(0, 10).replaceAll('-', '');

    const displayTideTime = (value) => {
      const [date, time] = value.split(' ');
      const [year, month, day] = date.split('-').map(Number);
      const [hour, minute] = time.split(':').map(Number);
      const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: 'UTC' })
        .format(new Date(Date.UTC(year, month - 1, day, 12)));
      const hour12 = hour % 12 || 12;
      return `${weekday} ${hour12}:${String(minute).padStart(2, '0')} ${hour >= 12 ? 'PM' : 'AM'}`;
    };

    const fetchJson = async (url) => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, {
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      } finally {
        window.clearTimeout(timeout);
      }
    };

    roots.forEach((root) => {
      const get = (selector) => root.querySelector(selector);
      const copy = JSON.parse(get('[data-fa-report-copy]').textContent);
      const stationSelect = get('[data-fa-station]');
      const dashboard = get('[data-fa-dashboard]');
      const status = get('[data-fa-status]');
      let requestVersion = 0;

      const cacheKey = (stationId) => `fa_report_cache_${stationId}`;

      const setActiveStation = (stationId) => {
        stationSelect.value = stationId;
        root.querySelectorAll('[data-fa-station-chip]').forEach((chip) => {
          chip.setAttribute('aria-pressed', chip.dataset.faStationChip === stationId ? 'true' : 'false');
        });
      };

      const readCache = (stationId) => {
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey(stationId)) || 'null');
          if (!cached || Date.now() - cached.timestamp > CACHE_TTL) return null;
          return cached.payload;
        } catch {
          return null;
        }
      };

      const writeCache = (stationId, payload) => {
        try {
          sessionStorage.setItem(cacheKey(stationId), JSON.stringify({ timestamp: Date.now(), payload }));
        } catch {
          // Storage can be unavailable in private browsing; the live report still works.
        }
      };

      const renderReport = (payload, source = 'live') => {
        const { stationId, period, upcoming, water, alerts, score } = payload;
        const station = STATIONS[stationId];
        const nextHigh = upcoming.find((item) => item.type === 'H');
        const nextLow = upcoming.find((item) => item.type === 'L');

        get('[data-fa-location]').textContent = station.name;
        get('[data-fa-updated]').textContent = `${copy.updated} ${new Date(payload.updatedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
        get('[data-fa-score]').textContent = Number.isFinite(score) ? score : '—';
        get('[data-fa-score-note]').textContent = Number.isFinite(score)
          ? (score >= 82 ? copy.excellent : score >= 62 ? copy.good : copy.caution)
          : copy.unavailable;
        get('[data-fa-high]').textContent = nextHigh ? displayTideTime(nextHigh.t) : copy.unavailable;
        get('[data-fa-high-height]').textContent = nextHigh ? `${Number(nextHigh.v).toFixed(1)} ft MLLW` : '—';
        get('[data-fa-low]').textContent = nextLow ? displayTideTime(nextLow.t) : copy.unavailable;
        get('[data-fa-low-height]').textContent = nextLow ? `${Number(nextLow.v).toFixed(1)} ft MLLW` : '—';
        get('[data-fa-water]').textContent = water ? `${Number(water).toFixed(1)}°F` : copy.unavailable;
        get('[data-fa-wind]').textContent = period.windSpeed || copy.unavailable;
        get('[data-fa-wind-direction]').textContent = period.windDirection || '—';
        get('[data-fa-forecast]').textContent = period.shortForecast || copy.unavailable;
        get('[data-fa-temperature]').textContent = Number.isFinite(period.temperature)
          ? `${period.temperature}°${period.temperatureUnit || 'F'}`
          : '—';

        const tideList = get('[data-fa-tides]');
        tideList.innerHTML = '';
        if (!upcoming.length) {
          const li = document.createElement('li');
          li.innerHTML = `<strong>—</strong><span>${copy.unavailable}</span><small>—</small>`;
          tideList.appendChild(li);
        } else {
          upcoming.slice(0, 4).forEach((item) => {
            const li = document.createElement('li');
            const type = item.type === 'H' ? copy.high : copy.low;
            li.innerHTML = `<strong>${type}</strong><span>${displayTideTime(item.t)}</span><small>${Number(item.v).toFixed(1)} ft</small>`;
            tideList.appendChild(li);
          });
        }

        const alertBox = get('[data-fa-alerts]');
        const alertCount = get('[data-fa-alert-count]');
        alertBox.innerHTML = '';
        alertCount.textContent = alerts.length === 1 ? `1 ${copy.activeAlert}` : `${alerts.length} ${copy.activeAlerts}`;
        if (!alerts.length) {
          alertBox.innerHTML = `<div class="fa-report__alert fa-report__alert--clear">${copy.noAlerts}</div>`;
        } else {
          alerts.slice(0, 3).forEach((alert) => {
            const item = document.createElement('div');
            item.className = 'fa-report__alert';
            item.textContent = alert.headline || alert.event || copy.activeAlert;
            alertBox.appendChild(item);
          });
        }

        dashboard.hidden = false;
        dashboard.dataset.ready = 'true';
        status.textContent = source === 'cache' ? copy.cached : '';
      };

      const moveToDashboard = () => {
        if (!window.matchMedia('(max-width: 760px)').matches) return;
        window.setTimeout(() => {
          dashboard.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 80);
      };

      const loadReport = async ({ useCache = true, userInitiated = false } = {}) => {
        const stationId = stationSelect.value;
        const station = STATIONS[stationId];
        const currentRequest = ++requestVersion;
        localStorage.setItem('fa_report_station', stationId);
        setActiveStation(stationId);

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('station', stationId);
        window.history.replaceState({}, '', currentUrl);

        const cached = useCache ? readCache(stationId) : null;
        if (cached) {
          renderReport(cached, 'cache');
          if (userInitiated) moveToDashboard();
        } else {
          dashboard.hidden = dashboard.dataset.ready !== 'true';
          if (!dashboard.hidden) get('[data-fa-location]').textContent = station.name;
          status.textContent = copy.loading;
        }

        root.setAttribute('aria-busy', 'true');

        const tideUrl = `https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?product=predictions&application=FishingAnonymous&begin_date=${apiDate()}&range=48&datum=MLLW&station=${stationId}&time_zone=lst_ldt&units=english&interval=hilo&format=json`;
        const waterUrl = `https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?product=water_temperature&application=FishingAnonymous&date=latest&station=${stationId}&time_zone=lst_ldt&units=english&format=json`;
        const pointsUrl = `https://api.weather.gov/points/${station.lat},${station.lon}`;
        const alertsUrl = `https://api.weather.gov/alerts/active?point=${station.lat},${station.lon}`;

        try {
          const [tideResult, waterResult, pointsResult, alertsResult] = await Promise.allSettled([
            fetchJson(tideUrl),
            fetchJson(waterUrl),
            fetchJson(pointsUrl),
            fetchJson(alertsUrl)
          ]);
          if (currentRequest !== requestVersion) return;

          const tideData = tideResult.status === 'fulfilled' ? tideResult.value : { predictions: [] };
          const waterData = waterResult.status === 'fulfilled' ? waterResult.value : null;
          const pointsData = pointsResult.status === 'fulfilled' ? pointsResult.value : null;
          const alertsData = alertsResult.status === 'fulfilled' ? alertsResult.value : { features: [] };
          if (tideResult.status !== 'fulfilled' && pointsResult.status !== 'fulfilled') {
            throw new Error('Primary data sources unavailable');
          }

          const forecastUrl = pointsData?.properties?.forecastHourly || pointsData?.properties?.forecast;
          const forecastData = forecastUrl ? await fetchJson(forecastUrl).catch(() => null) : null;
          if (currentRequest !== requestVersion) return;

          const period = forecastData?.properties?.periods?.[0] || {};
          const nowLocal = formatStationNow();
          const upcoming = (tideData.predictions || []).filter((item) => item.t >= nowLocal).slice(0, 6);
          const water = waterData?.data?.[0]?.v || null;
          const alerts = (alertsData?.features || []).map((alert) => ({
            headline: alert.properties?.headline || '',
            event: alert.properties?.event || ''
          }));
          const windValue = Number.parseInt(period.windSpeed, 10);
          const hasWeather = Number.isFinite(windValue) || Boolean(period.shortForecast);
          const stormy = /thunder|storm|squall/i.test(period.shortForecast || '');
          const score = hasWeather
            ? Math.max(25, Math.min(100, 100 - Math.max(0, (windValue || 0) - 8) * 3 - Math.min(alerts.length, 2) * 20 - (stormy ? 20 : 0)))
            : null;
          const payload = { stationId, period, upcoming, water, alerts, score, updatedAt: Date.now() };

          renderReport(payload, 'live');
          writeCache(stationId, payload);
          if (userInitiated && !cached) moveToDashboard();
          track('FishingReportLoaded', {
            station_id: stationId,
            station_name: station.name,
            trip_score: score,
            cache_hit: Boolean(cached)
          });
        } catch (error) {
          if (currentRequest !== requestVersion) return;
          status.textContent = cached ? copy.cached : copy.error;
          track('FishingReportError', { station_id: stationId, message: String(error.message || error) });
        } finally {
          if (currentRequest === requestVersion) root.removeAttribute('aria-busy');
        }
      };

      const queryStation = new URLSearchParams(window.location.search).get('station');
      const savedStation = localStorage.getItem('fa_report_station');
      const initialStation = STATIONS[queryStation] ? queryStation : (STATIONS[savedStation] ? savedStation : stationSelect.value);
      setActiveStation(initialStation);

      root.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-fa-station-chip]');
        if (chip) {
          stationSelect.value = chip.dataset.faStationChip;
          loadReport({ useCache: true, userInitiated: true });
          return;
        }

        const refresh = event.target.closest('[data-fa-refresh]');
        if (refresh) {
          loadReport({ useCache: false, userInitiated: false });
          return;
        }

        const build = event.target.closest('[data-fa-build]');
        if (build) loadReport({ useCache: true, userInitiated: true });
      });

      stationSelect.addEventListener('change', () => {
        loadReport({ useCache: true, userInitiated: true });
      });

      get('[data-fa-signup]')?.addEventListener('click', () => {
        track('FishingReportSignup', { station_id: stationSelect.value });
      });

      root.querySelectorAll('[data-fa-copy-code]').forEach((button) => {
        const originalLabel = button.textContent;
        button.addEventListener('click', async () => {
          const code = button.dataset.faCopyCode;
          try {
            await navigator.clipboard.writeText(code);
          } catch {
            const field = document.createElement('textarea');
            field.value = code;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.appendChild(field);
            field.select();
            document.execCommand('copy');
            field.remove();
          }
          button.textContent = copy.copied;
          track('PartnerCodeCopy', { partner: 'shady-rays', code });
          window.setTimeout(() => { button.textContent = originalLabel; }, 1800);
        });
      });

      root.querySelectorAll('[data-fa-partner]').forEach((link) => {
        link.addEventListener('click', () => {
          const url = new URL(link.href);
          const params = new URLSearchParams(window.location.search);
          const subid = [params.get('utm_source'), params.get('utm_campaign'), params.get('utm_content')]
            .filter(Boolean)
            .join('-')
            .slice(0, 100);
          if (subid) url.searchParams.set('subid', subid);
          link.href = url.toString();
          track('PartnerOutboundClick', {
            partner: link.dataset.faPartner,
            station_id: stationSelect.value,
            subid
          });
        });
      });

      loadReport({ useCache: true, userInitiated: false });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-last-mango"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-fa-mango]');
    if (!root || root.dataset.faReady === 'true') return;
    root.dataset.faReady = 'true';

    const catalog = root.querySelector('[data-fa-mango-catalog]');
    const cards = catalog ? Array.from(catalog.querySelectorAll('[data-fa-mango-product]')) : [];
    const filters = catalog ? Array.from(catalog.querySelectorAll('[data-fa-mango-filter]')) : [];
    const moreButton = catalog ? catalog.querySelector('[data-fa-mango-more]') : null;
    const count = catalog ? catalog.querySelector('[data-fa-mango-count]') : null;
    const empty = catalog ? catalog.querySelector('[data-fa-mango-empty]') : null;
    const batchSize = Number(root.dataset.batchSize) || 12;
    let activeFilter = 'all';
    let visibleLimit = batchSize;

    cards.forEach((card) => {
      const link = card.querySelector('[data-product-title]');
      const badge = card.querySelector('.fa-mango__product-badge');
      if (link && badge && (link.dataset.productTitle || '').toLowerCase().startsWith('preorder:')) {
        badge.textContent = root.dataset.preorderLabel || badge.textContent;
      }
    });

    const matchesFilter = (card) => {
      if (activeFilter === 'all') return true;
      return (card.dataset.category || '').split(' ').includes(activeFilter);
    };

    const drawCatalog = () => {
      const matchingCards = cards.filter(matchesFilter);
      cards.forEach((card) => {
        const position = matchingCards.indexOf(card);
        card.hidden = position === -1 || position >= visibleLimit;
      });

      const shown = Math.min(visibleLimit, matchingCards.length);
      if (count) {
        count.textContent = (count.dataset.countTemplate || '__SHOWN__ / __TOTAL__')
          .replace('__SHOWN__', String(shown))
          .replace('__TOTAL__', String(matchingCards.length));
      }
      if (moreButton) moreButton.hidden = shown >= matchingCards.length;
      if (empty) empty.hidden = matchingCards.length !== 0;
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeFilter = filter.dataset.faMangoFilter || 'all';
        visibleLimit = batchSize;
        filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
        drawCatalog();
      });
    });

    if (moreButton) {
      moreButton.addEventListener('click', () => {
        visibleLimit += batchSize;
        drawCatalog();
      });
    }

    drawCatalog();

    root.querySelectorAll('[data-fa-mango-link]').forEach((link) => {
      link.addEventListener('click', () => {
        const payload = {
          event: 'PartnerOutboundClick',
          partner: 'last-mango',
          placement: link.dataset.placement || 'unknown',
          product: link.dataset.productTitle || undefined
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        if (typeof window.fbq === 'function') window.fbq('trackCustom', 'PartnerOutboundClick', payload);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-report-launcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-fa-report-entry]').forEach((link) => {
      link.addEventListener('click', () => {
        const detail = { placement: 'homepage_fixed', destination: '/pages/fishing-report' };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'FishingReportEntryClick', ...detail });
        if (typeof window.fbq === 'function') window.fbq('trackCustom', 'FishingReportEntryClick', detail);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-shady-rays-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-fa-shady]');
    if (!root || root.dataset.faReady === 'true') return;
    root.dataset.faReady = 'true';

    const copyNode = root.querySelector('[data-fa-shady-copy]');
    const copy = copyNode ? JSON.parse(copyNode.textContent) : { copy: 'Copy code', copied: 'Copied' };
    const params = new URLSearchParams(window.location.search);
    const attribution = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
      .map((key) => params.get(key))
      .filter(Boolean)
      .join('|')
      .slice(0, 180);

    const track = (name, detail = {}) => {
      const payload = { partner: 'shady-rays', ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, payload);
      document.dispatchEvent(new CustomEvent(`fa:${name}`, { detail: payload }));
    };

    root.querySelectorAll('[data-fa-partner-link]').forEach((link) => {
      if (attribution) {
        const url = new URL(link.href);
        url.searchParams.set('subid', attribution);
        link.href = url.toString();
      }
      link.addEventListener('click', () => {
        track('PartnerOutboundClick', {
          placement: link.dataset.placement || 'unknown',
          subid: attribution
        });
      });
    });

    const copyCode = async (button) => {
      const code = button.dataset.faCopyCode;
      try {
        await navigator.clipboard.writeText(code);
      } catch {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }

      root.querySelectorAll('[data-fa-copy-label]').forEach((label) => { label.textContent = copy.copied; });
      button.setAttribute('aria-label', `${copy.copied}: ${code}`);
      track('PartnerCodeCopy', { code });
      window.setTimeout(() => {
        root.querySelectorAll('[data-fa-copy-label]').forEach((label) => { label.textContent = copy.copy; });
      }, 1800);
    };

    root.querySelectorAll('[data-fa-copy-code]').forEach((button) => {
      button.addEventListener('click', () => copyCode(button));
    });

    const dock = root.querySelector('[data-fa-mobile-dock]');
    const hero = root.querySelector('.fa-shady__hero');
    if (dock && hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        dock.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.08 });
      observer.observe(hero);
    }

    track('PartnerLandingView', { subid: attribution });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
